<fin-skip-link [main]="main" />
<fin-cms-global-disruption-banner />
<fin-loyalty-global-notification />
<router-outlet name="header" />

<main #main [class.layout--footer-open]="isFooterOpen$ | async" role="main">
  <router-outlet />

  @if (enablePageFeedback) {
    <fin-qualtrics-embedded-page-feedback [pageType]="'myFplus'" />
  }
</main>

<footer>
  <router-outlet name="footer" />
</footer>
